import { render } from "./ContractExtraFields.vue?vue&type=template&id=3046e3d4"
import script from "./ContractExtraFields.vue?vue&type=script&lang=js"
export * from "./ContractExtraFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__